import { IApprovalRequestsState } from "../types";

const state = (): IApprovalRequestsState => ({
  approvalRequests: [],
  selectedApprovalRequest: null,
  totalRecords: 0,
  page: 1,
  pageSize: 10,
  isFetchingApprovalRequests: false,
  isFetchingApprovalRequestDetail: false,
  isApprovalRequestActionLoading: false,
});

export default state;
